import $ from "jquery";
import { uaCheck,showTab,showAccordion } from "./modules/utils";

// fixedバナー
function fixedBnrFunc(){
  $(window).scroll( () =>{
    const scroll = $(window).scrollTop();
    if (scroll >= 100){
      $('.fixed-bnr').addClass('is-active');
    }else{
      $('.fixed-bnr').removeClass('is-active');
    }
  })
}

// ハンバーガーボタン
const topHeaderFnc = () => {
  $('.nav-toggle').on('click', () => {
    $('.nav-toggle').toggleClass('is-open');
    $('.nav').toggleClass('is-open');
    $('.hbg-bg').toggleClass('is-open');
    $('body').toggleClass('is-open');
  });
  $('.nav').on('click', () => {
    $('.nav').toggleClass('is-open');
    $('.nav-toggle').toggleClass('is-open');
    $('.hbg-bg').toggleClass('is-open');
    $('body').toggleClass('is-open');
  });
  $('.hbg-bg').on('click', () => {
    $('.nav').toggleClass('is-open');
    $('.nav-toggle').toggleClass('is-open');
    $('.hbg-bg').toggleClass('is-open');
    $('body').toggleClass('is-open');
  });
};

function tabActive(){
  $('.tab-title').on('click',(e)=>{
    const target = e.currentTarget;
    $(".tab-title").removeClass("active");
    $(target).addClass("active");
  });
}


window.addEventListener("DOMContentLoaded", () => {
  uaCheck();
  topHeaderFnc();
  showTab('.tab-titles','.tab-contents');
  showAccordion('.accordion-title');
  fixedBnrFunc();
  tabActive();
});
